import {ngAsync} from 'shared/utils/ng-@decorators';
import {unRestangularize} from 'shared/utils/data-service-utils';
import type {ILogService} from 'angular';
import bind from 'bind-decorator';
import type {AnyObject} from 'typings/portaro.fe.types';

/**
 * @ngdoc service
 * @name searchDataService
 * @module portaro.services
 *
 * @requires Restangular
 *
 * @description
 * Data service for common searching (/api/search?...)
 */
export default class CommonSearchDataService<T = any> {
    public static serviceName = 'commonSearchDataService';

    private static readonly SEARCH_ROUTE = 'search';

    private static readonly DEFAULT_EXPORTS_PARAM = 'portaroSearchItemParagraph,portaroSearchItemMoreParagraph';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService, private $log: ILogService) {
    }

    @bind
    @ngAsync()
    @unRestangularize()
    public async query<TYPE = T>(params?: AnyObject): Promise<TYPE> {

        const finalParams = Object.assign({}, {exports: CommonSearchDataService.DEFAULT_EXPORTS_PARAM}, params);

        this.$log.info('Params: ', params);

        return this.Restangular
                   .one(CommonSearchDataService.SEARCH_ROUTE)
                   .get(finalParams);
    }
}
